module.exports = __webpack_public_path__ + "media/CC.d300a85b.mp4";